/* eslint-disable */
import md5 from 'md5';
// import pako from 'pako';

const processDB = {};
const oldVersion = [
  'fund-detail-stock-data-cache',
];
const headName = 'fund-detail-stock-data-cache-v';
const version = '16';
const LOCAL_CACHE_ID = `${headName}${version}`;

// 清除老缓存
let oldV = version-1;
while(oldV>0){
  try{
    localStorage.removeItem(`${headName}${oldV}`);
  }catch(err){
    console.error(err);
  }
  oldV--;
}

// 清除老缓存
try {
  oldVersion.map((v) => {
    localStorage.removeItem(v);
  });
} catch (err) {
  console.error(err);
}

// 判断数据是否是非空数组
const isNotEmptyArr = (row) => {
  if (row) {
    if (row.hasOwnProperty('Success')) {
      if (!row.Success) {
        return false;
      }
    }
    if (row.hasOwnProperty('resultCode')) {
      if (row.resultCode === 0) {
        return true;
      }
    }
    if (row.success) {
      return true;
    }
    if (row.Success) {
      return true;
    }
    if (row.hasOwnProperty('ErrCode')) {
      if (row.ErrCode === 0) {
        return true;
      }
    }
    if (row.hasOwnProperty('errorCode')) {
      if (row.errorCode === 0) {
        return true;
      }
    }
    if (row.hasOwnProperty('ErrorCode')) {
      if (row.ErrorCode === 0) {
        return true;
      }
    }
  }
  return false;
};
// const isNotEmptyArr = () => true;

/**
 * 进程缓存
 * 将接口数据缓存至运行内存
 * @param {number} duration          缓存时间ms
 * @param {function} rules          数据完整性规则
 */
// eslint-disable-next-line max-len
export const Caches = (duration = 60 * 60 * 1000, rule = isNotEmptyArr) => (target, property, descriptor) => {
  if (!descriptor) return;
  const oldValue = descriptor.value || (() => {});
  // eslint-disable-next-line no-param-reassign
  descriptor.value = caches(property, oldValue.bind(target), duration, rule);
};
// eslint-disable-next-line max-len
// eslint-disable-next-line no-async-promise-executor
export const caches = (prop, fun, duration, rule) => (...arg) => new Promise(async (resolve, reject) => {
  // window.trackLog('获取接口缓存开始', prop);
  const id = `ckey_${md5(JSON.stringify(arg))}`;

  if (!processDB[prop]) {
    processDB[prop] = {};
  }

  // 查找缓存
  const data = processDB[prop][id];
  
  // 读取进程缓存
  if (data && data.endTime > new Date().getTime()) {
    //误差3小时以上 改本地时间会导致
    if (Math.abs(data.endTime - new Date().getTime()) > 1000*60*60*3 ) {
      //不要缓存
    }else{
      console.log('---------1');
      console.log(arg);
      resolve(data.row);
      return;
    }
    
  }

  // 读取离线缓存
  let cache = null;
  try {
    const localDBStr = localStorage.getItem(LOCAL_CACHE_ID);
    // window.trackLog('获取缓存字符串', prop);
    if (localDBStr) {
      // const decodeStr = pako.inflate(localDBStr, { to: 'string' });
      const localDB = JSON.parse(localDBStr);
      // window.trackLog('解析缓存字符串', prop);
      if (localDB && localDB[prop]) {
        cache = localDB[prop][id];
      }
      // window.trackLog('查找缓存', prop);
    }
  } catch (err) { console.error(err); }
  if (cache && cache.endTime && (cache.endTime > new Date().getTime())) {
    //误差3小时以上 改本地时间会导致
    if (Math.abs(cache.endTime - new Date().getTime()) > 1000*60*60*3 ) {
      //不要缓存
    }else{
      // window.trackLog('获取接口离线缓存', prop);
      console.log('---------2');
      console.log(arg);
      resolve(cache.row);
      return;
    }
  }

  // 判断是不是断网

////////////////////////////////
  // eslint-disable-next-line no-unused-expressions
  // !navigator.onLine && resolve({ errorMsg: 'NET_ERROR' });
///////////

/////////////////////////////////
//////////////////////////////////////
//////////////////////////
//////////////////////////
//////////////////////////////////////////
///////////////////////////////////////////////////////
//////////
/////////
////////
///////////

  // 读接口，写入缓存
  // window.trackLog('开始请求接口', prop);

  // 10s超时
  const timer = setTimeout(()=>{
    resolve({ errorMsg: 'NET_ERROR' });
  }, 10*1000);

  fun(...arg).then((res) => {
    // window.trackLog('返回数据', prop, res);
    clearTimeout(timer);
    resolve(res);
    
    if (rule && rule(res)) {
      const newData = {
        row: res,
        endTime: new Date().getTime() + duration,
        crateTime: new Date().getTime(),
        args: arg,
      };

      processDB[prop][id] = newData;

      let newLocalDB = {};
      try {
        // 合并运行数据库和本地数据库
        let localDB = {};
        const localDBStr = localStorage.getItem(LOCAL_CACHE_ID);
        if (localDBStr) {
          // const decodeStr = pako.inflate(localDBStr, { to: 'string' });
          // localDB = JSON.parse(decodeStr);
          localDB = JSON.parse(localDBStr);
        }
        newLocalDB = { ...localDB };
        newLocalDB[prop] = Object.assign(newLocalDB[prop] || {}, processDB[prop]);
        // eslint-disable-next-line no-throw-literal
        // throw 'Failed to execute \'setItem\' on \'Storage\': Setting the value of \'feature\' exceeded the quota.';

        // const encodeStr = pako.deflate(JSON.stringify(newLocalDB), { to: 'string' });
        // localStorage.setItem(LOCAL_CACHE_ID, encodeStr);
        localStorage.setItem(LOCAL_CACHE_ID, JSON.stringify(newLocalDB));
      } catch (err) {
        console.error(err);
        // 缓存体积大于500K
        if (/quota/igm.test(err)) {
          let list = [];
          Object.keys(newLocalDB).map((apiName) => {
            Object.keys(newLocalDB[apiName]).map((key) => {
              list.push({
                apiName,
                key,
                time: newLocalDB[apiName][key].crateTime,
              });
            });
          });
          list = list.sort((a, b) => a.time - b.time);
          // 删除10条最早创建的数据
          list.map(({ apiName, key }, index) => {
            if (index < 10) {
              delete newLocalDB[apiName][key];
            }
          });

          // const encodeStr = pako.deflate(JSON.stringify(newLocalDB), { to: 'string' });
          // localStorage.setItem(LOCAL_CACHE_ID, encodeStr);
          localStorage.setItem(LOCAL_CACHE_ID, JSON.stringify(newLocalDB));
        }
        console.error(err);
      }
    }
    // window.trackLog('写入缓存', prop);
  }).catch(err=>{
    // 网络错误，尝试拿缓存失效的数据展示
    // 读取离线缓存
    let cache = null;
    try {
      const localDBStr = localStorage.getItem(LOCAL_CACHE_ID);
      // window.trackLog('获取缓存字符串', prop);
      if (localDBStr) {
        // const decodeStr = pako.inflate(localDBStr, { to: 'string' });
        const localDB = JSON.parse(localDBStr);
        // window.trackLog('解析缓存字符串', prop);
        if (localDB && localDB[prop]) {
          cache = localDB[prop][id];
        }
        // window.trackLog('查找缓存', prop);
      }
    } catch (err) { console.error(err); }
    if (cache) {
      // window.trackLog('获取接口离线缓存', prop);
      console.log('---------3');
      console.log(arg);
      resolve(cache.row);
      return;
    }
    resolve({ errorMsg: 'NET_ERROR' });
  });
});


/**
 * 走势图接口数据转换
 */
export const TransformChartData = () => (target, property, descriptor) => {
  if (!descriptor) return;
  const oldValue = descriptor.value || (() => {});
  // eslint-disable-next-line no-param-reassign
  descriptor.value = transformChartData(property, oldValue.bind(target));
};

// eslint-disable-next-line max-len
// eslint-disable-next-line no-async-promise-executor
export const transformChartData = (prop, fun) => (...arg) => new Promise(async (resolve, reject) => {
  // 读接口，写入缓存
  fun(...arg).then((res) => {
    // fetch(`http://172.31.35.45:3000/?data=${encodeURIComponent(JSON.stringify(arg))}`)
    let resultStr = JSON.stringify(res);
    let result = {};
    const config = [
      // 公共
      ['"data":', '"Datas":'],
      ['pdate', 'PDATE'],
      ['expansion', 'Expansion'],
      ['changeInfo', 'FundMNChangeList'],
      ['DIY', 'FundMNChangeList'], // ?
      ['sTYPE', 'STYPE'],// ?
      // 累计收益
      ['fundTypeYield', 'FUNDTYPEYIED'],
      ['indexYield', 'INDEXYIED'],
      ['yield', 'YIELD'],
      ['aboutAcc', 'FundMNYieldBase'],
      ['code', 'INDEXCODE'],
      ['name', 'INDEXNAME'],
      ['benchQuote', 'BENCCHQUOTE'],
      // 换接口后，对齐之前的字段
      ['BENCHQUOTE', 'BENCCHQUOTE'],
      ['FUNDTYPEYIELD', 'FUNDTYPEYIED'],
      ['INDEXYIELD', 'INDEXYIED'],
    ];
    config.map((c) => {
      resultStr = resultStr.replace(new RegExp(c[0], 'g'), c[1]);
    });
    if (resultStr) {
      result = JSON.parse(resultStr);
    }
    !result.Expansion && (result.Expansion = {});
    !result.Expansion.FundMNChangeList && (result.Expansion.FundMNChangeList = []);
    !result.Expansion.FundMNYieldBase && (result.Expansion.FundMNYieldBase = []);

    // 将变动点数据拼回到数组中
    if (result.Datas && result.Datas[0]) {
      const firstData = result.Datas[0];
      const lastData = result.Datas[result.Datas.length - 1];
      const key = firstData?.PDATE && 'PDATE' || firstData?.FSRQ && 'FSRQ' || '';
      console.log(key);
      if ( key ) {
        result.Expansion.FundMNChangeList.map(m=>{
          if ( m[key] ) {
            if (firstData[key] < m[key] && lastData[key] > m[key]) {
              // 新街口需要加入 这些字段
              result.Datas.push(m);
            }
            // result.Datas.push(m);
          }
        })
        result.Datas = result.Datas.sort((a,b)=>{
          return (a[key].replace(/\-/g,'')-0) - (b[key].replace(/\-/g,'')-0);
        });
      }
    }
    resolve(result);
  }).catch((err) => {
    console.error(err);
    reject();
  });
});

/**
 * 走势图接口数据转换
 */
 export const TransformHKChartData = () => (target, property, descriptor) => {
  if (!descriptor) return;
  const oldValue = descriptor.value || (() => {});
  // eslint-disable-next-line no-param-reassign
  descriptor.value = transformHKChartData(property, oldValue.bind(target));
};
// eslint-disable-next-line max-len
// eslint-disable-next-line no-async-promise-executor
export const transformHKChartData = (prop, fun) => (...arg) => new Promise(async (resolve, reject) => {
  // 读接口，写入缓存
  fun(...arg).then((res) => {
    // fetch(`http://172.31.35.45:3000/?data=${encodeURIComponent(JSON.stringify(arg))}`)
    let resultStr = JSON.stringify(res);
    let result = {};
    const config = [
      // 公共
      ['"data":', '"Datas":'],
      ['pdate', 'PDATE'],
      ['expansion', 'Expansion'],
      ['changeInfo', 'FundMNChangeList'],
      ['DIY', 'FundMNChangeList'],
      ['sTYPE', 'STYPE'],
      // 累计收益
      ['fundTypeYield', 'FUNDTYPEYIED'],
      ['indexYield', 'INDEXYIED'],
      ['HSI', 'INDEXYIED'],
      ['yield', 'YIELD'],
      ['aboutAcc', 'FundMNYieldBase'],
      ['code', 'INDEXCODE'],
      ['name', 'INDEXNAME'],
      ['benchQuote', 'BENCCHQUOTE'],
    ];
    config.map((c) => {
      resultStr = resultStr.replace(new RegExp(c[0], 'g'), c[1]);
    });
    if (resultStr) {
      result = JSON.parse(resultStr);
    }
    !result.Expansion && (result.Expansion = {});
    !result.Expansion.FundMNChangeList && (result.Expansion.FundMNChangeList = []);
    !result.Expansion.FundMNYieldBase && (result.Expansion.FundMNYieldBase = []);

    // 将变动点数据拼回到数组中
    if (result.Datas && result.Datas[0]) {
      const firstData = result.Datas[0];
      const lastData = result.Datas[result.Datas.length - 1];
      const key = firstData?.PDATE && 'PDATE' || firstData?.FSRQ && 'FSRQ' || '';
      console.log(key);
      if ( key ) {
        result.Expansion.FundMNChangeList.map(m=>{
          if ( m[key] ) {
            if (firstData[key] < m[key] && lastData[key] > m[key]) {
              // 新街口需要加入 这些字段
              result.Datas.push(m);
            }
            // result.Datas.push(m);
          }
        })
        result.Datas = result.Datas.sort((a,b)=>{
          return (a[key].replace(/\-/g,'')-0) - (b[key].replace(/\-/g,'')-0);
        });
      }
    }
    resolve(result);
  }).catch((err) => {
    console.error(err);
    reject();
  });
});